<template>
  <div class="loader">
    <section class="loading">
      <div class="container" style="height=200px;">
        <div class="loader text-center">
          <i class="fa fa-3x fa-spin fa-spinner"></i>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Loader'
};
</script>

<style scoped lang="scss">
.loading {
  height: 1800px;
  padding: 10%;
  flex: 1;
}
.loader i {
  color: #2d6e0f;
}
</style>
